<section class="detail-page">

  <!-- Top Navigation Bar -->
  <div class="detail-nav">
    <a class="back-link" [routerLink]="'/materials'">
      <i class="material-icons">arrow_back</i>
      <span>Back to Library</span>
    </a>

    <div class="nav-actions" *ngIf="hasEditPermission">
      <button class="action-btn edit-btn" (click)="editMaterial()" matTooltip="Edit Material" matTooltipPosition="below">
        <i class="material-icons">edit</i>
        <span>Edit</span>
      </button>
      <button class="action-btn delete-btn" (click)="confirmationDelete()" matTooltip="Delete Material" matTooltipPosition="below">
        <i class="material-icons">delete_outline</i>
        <span>Delete</span>
      </button>
    </div>
  </div>

  <!-- Main Content -->
  <div class="detail-content">
    <div class="detail-grid">

      <!-- Left: Image Gallery -->
      <div class="gallery-section">
        <div class="main-image-container" oncontextmenu="return false" [style.aspect-ratio]="getMainAspectRatio()">
          <div class="watermark-overlay">
            <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
              <defs>
                <pattern id="websiteName" class="svg-pattern-1" patternUnits="userSpaceOnUse" width="400" height="200">
                  <text id="name1" class="svg-pattern-1-text">eduhealthcare.com</text>
                </pattern>
                <pattern class="svg-pattern-2" xlink:href="#websiteName">
                  <text id="name2" class="svg-pattern-2-text">EDU Healthcare</text>
                </pattern>
                <pattern id="combo" xlink:href="#websiteName" patternTransform="rotate(-45)">
                  <use xlink:href="#name1" />
                  <use xlink:href="#name2" />
                </pattern>
              </defs>
              <rect width="100%" height="100%" fill="url(#combo)" />
            </svg>
          </div>

          <img *ngIf="largeImageToShow" class="main-image"
               [alt]="itemToBeViewed?.title || 'Therapy material preview'"
               [src]="largeImageToShow | imageSizeUrl: '720w'"
               [attr.srcset]="(largeImageToShow | imageSizeUrl: '480w') + ' 480w, ' + (largeImageToShow | imageSizeUrl: '720w') + ' 720w, ' + (largeImageToShow | imageSizeUrl: '960w') + ' 960w'"
               sizes="(max-width: 992px) 100vw, 50vw"
               fetchpriority="high"
               onerror="this.src='/assets/images/no_image_available.jpeg';" />
          <img *ngIf="!largeImageToShow && itemToBeViewed?.defaultImage" class="main-image"
               [alt]="itemToBeViewed?.title || 'Therapy material preview'"
               [src]="itemToBeViewed.defaultImage | imageSizeUrl: '720w'"
               [attr.srcset]="(itemToBeViewed.defaultImage | imageSizeUrl: '480w') + ' 480w, ' + (itemToBeViewed.defaultImage | imageSizeUrl: '720w') + ' 720w, ' + (itemToBeViewed.defaultImage | imageSizeUrl: '960w') + ' 960w'"
               sizes="(max-width: 992px) 100vw, 50vw"
               fetchpriority="high"
               onerror="this.src='/assets/images/no_image_available.jpeg';" />

          <div *ngIf="!largeImageToShow && !itemToBeViewed?.defaultImage" class="image-placeholder">
            <i class="material-icons">description</i>
            <span>No preview available</span>
          </div>
        </div>

        <!-- Thumbnail Strip: outer slot reserves vertical space so the strip
             mounting after data load doesn't shift the page (CLS). -->
        <div class="thumbnail-strip-slot">
          <div *ngIf="itemToBeViewed?.fileImageArray?.length > 0" class="thumbnail-strip">
            <div *ngFor="let snapshotImage of itemToBeViewed.fileImageArray; let i = index;" class="thumbnail-item" [class.active]="selectedImage === snapshotImage" (click)="changeLargeImage(snapshotImage)">
              <div class="thumb-watermark-overlay">
                <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
                  <defs>
                    <pattern id="smallWebsiteName" class="svg-pattern-1" patternUnits="userSpaceOnUse" width="100" height="50">
                      <text id="smallName1" class="svg-pattern-1-text">eduhealthcare.com</text>
                    </pattern>
                    <pattern id="smallCombo" xlink:href="#smallWebsiteName" patternTransform="rotate(-45)">
                      <use xlink:href="#smallName1" />
                    </pattern>
                  </defs>
                  <rect width="100%" height="100%" fill="url(#smallCombo)" />
                </svg>
              </div>
              <img class="thumb-img" [src]="snapshotImage | imageSizeUrl: '480w'" [alt]="'Page ' + (i + 1) + ' of ' + (itemToBeViewed?.title || 'material')" onerror="this.src='/assets/images/no_image_available.jpeg';" />
            </div>
          </div>

          <div *ngIf="itemToBeViewed?.fileImageArray?.length < 1 && itemToBeViewed?.defaultImage" class="thumbnail-strip">
            <div class="thumbnail-item active">
              <div class="thumb-watermark-overlay">
                <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
                  <defs>
                    <pattern id="singleSmallWebsiteName" class="svg-pattern-1" patternUnits="userSpaceOnUse" width="200" height="100">
                      <text id="singleSmallName1" class="svg-pattern-1-text" y="30" font-size="20">eduhealthcare.com</text>
                    </pattern>
                    <pattern id="singleSmallCombo" xlink:href="#singleSmallWebsiteName" patternTransform="rotate(-45)">
                      <use xlink:href="#singleSmallName1" />
                    </pattern>
                  </defs>
                  <rect width="100%" height="100%" fill="url(#singleSmallCombo)" />
                </svg>
              </div>
              <img class="thumb-img" [src]="itemToBeViewed.defaultImage | imageSizeUrl: '480w'" [alt]="itemToBeViewed?.title || 'Material preview'" onerror="this.src='/assets/images/no_image_available.jpeg';" />
            </div>
          </div>
        </div>
      </div>

      <!-- Right: Details -->
      <div class="details-section">
        <div class="details-card">
          <h1 class="material-title">{{ itemToBeViewed?.title }}</h1>

          <div class="meta-tags">
            <span class="meta-tag" *ngFor="let cat of itemToBeViewed?.categories ?? []">
              <i class="material-icons tag-icon">folder_open</i>
              {{ cat?.name || 'Unknown' }}
            </span>
            <span class="meta-tag sub-tag" *ngFor="let cat of itemToBeViewed?.categories ?? []" >
              <i class="material-icons tag-icon">subdirectory_arrow_right</i>
              {{ cat?.subCategory || 'N/A' }}
            </span>
          </div>

          <div class="description-block">
            <h2 class="section-label">Description</h2>
            <p class="description-text">{{ itemToBeViewed?.description }}</p>
          </div>

          <div class="detail-actions">
            @if (showDownloadBtn) {
              <button class="primary-action-btn" (click)="checkDownloadAccess()">
                <i class="material-icons">download</i>
                Download Material
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Related Materials -->
  <div class="related-section" *ngIf="allRelated?.length">
    <div class="related-header">
      <h2 class="related-title">Related Materials</h2>
      <p class="related-subtitle">Explore similar resources you might find useful</p>
    </div>

    <div class="related-grid">
      <div class="related-item" *ngFor="let relatedItem of allRelated | paginate: { itemsPerPage: itemsPerPage, currentPage: currentPage, totalItems: totalItemsCount }; let i = index;">
        <material-card [item]="relatedItem" (relatedItemSelected)="newMaterialIdRecieved($event)"></material-card>
      </div>
    </div>

    <nav class="related-pagination" aria-label="Related materials pagination" *ngIf="totalItemsCount > itemsPerPage">
      <pagination-template class="paginationController" #p="paginationApi" (pageChange)="changeThePage($event)">
        <ul class="ngx-pagination">
          <li class="pagination-previous" [class.disabled]="p.isFirstPage()">
            <a *ngIf="!p.isFirstPage()" rel="prev"
               [href]="getPageHref(p.getCurrent() - 1)"
               (click)="onPageLinkClick($event, p.getCurrent() - 1, p)">Previous</a>
            <span *ngIf="p.isFirstPage()" aria-disabled="true">Previous</span>
          </li>

          <li *ngFor="let page of p.pages; trackBy: trackByPageValue"
              [class.current]="p.getCurrent() === page.value"
              [class.ellipsis]="page.label === '...'">
            <a *ngIf="p.getCurrent() !== page.value && page.label !== '...'"
               [href]="getPageHref(page.value)"
               (click)="onPageLinkClick($event, page.value, p)"
               [attr.aria-label]="'Go to page ' + page.label">{{ page.label }}</a>
            <span *ngIf="p.getCurrent() === page.value" aria-current="page">{{ page.label }}</span>
            <span *ngIf="page.label === '...' && p.getCurrent() !== page.value">{{ page.label }}</span>
          </li>

          <li class="pagination-next" [class.disabled]="p.isLastPage()">
            <a *ngIf="!p.isLastPage()" rel="next"
               [href]="getPageHref(p.getCurrent() + 1)"
               (click)="onPageLinkClick($event, p.getCurrent() + 1, p)">Next</a>
            <span *ngIf="p.isLastPage()" aria-disabled="true">Next</span>
          </li>
        </ul>
      </pagination-template>
    </nav>
  </div>

  <!-- Empty Related -->
  <div class="related-empty" *ngIf="allRelated && allRelated.length === 0">
    <i class="material-icons">library_books</i>
    <p>No related materials found at this time.</p>
  </div>
</section>
